import { Component, OnInit } from '@angular/core';
import {HomeComponent} from '../home/home.component';
import {Observable} from 'rxjs/Observable';
import {DataService} from '../data.service';


@Component({
  selector: 'app-dash-board',
  templateUrl: './dash-board.component.html',
  styleUrls: ['./dash-board.component.css']
})
export class DashBoardComponent implements OnInit {
  constructor(public dataService: DataService) {
  }
  ngOnInit() {
    document.body.classList.add('home-bg-img');
  }
}



// WEBPACK FOOTER //
// C:/Users/pkwoy/Desktop/progressive-webb-app/src/app/dash-board/dash-board.component.ts